import { menuAnatomy } from "@ark-ui/react/menu";
import { defineSlotRecipe } from "@chakra-ui/react";

export default defineSlotRecipe({
  className: "chakra-menu",
  slots: menuAnatomy.keys(),
  base: {
    content: {
      borderRadius: "l2",
      boxShadow: "menu",
      minWidth: "184px" as any,
      padding: "1",
    },
    item: {
      borderRadius: "sm",
      fontSize: "sm",
      height: "8",
      lineHeight: "20px" as any,

      _hover: {
        background: "bg.hover",
      },

      "&[data-selected]": {
        background: "accent",
        color: "white",
      },
    },
  },
});
